import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass({
            'gallery-item-view': true,
        })
}
const _hoisted_2 = ["src"]

import { type PropType } from "vue";
import mediaGalleryImage from "../common/media-gallery-image.vue";
import { type MediaItem } from "../types";
// import zoomWrapper from "./zoom-wrapper.vue";
import { spacerUrl } from "../../../shared/empty-pixel";


export default /*@__PURE__*/_defineComponent({
  __name: 'media-gallery-view',
  props: {
    item: {
        type: Object as PropType<MediaItem>,
    },
    // selected: Boolean,
    lazy: Boolean,
    expandEnabled: Boolean,
},
  emits: ["expand"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.item == null)
      ? (_openBlock(), _createBlock(mediaGalleryImage, {
          key: 0,
          value: _unref(spacerUrl),
          size: { width: 700, height: 525 },
          "enforce-aspect-ratio": ""
        }, null, 8 /* PROPS */, ["value"]))
      : (__props.item.type === 'picture')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" <zoom-wrapper :active=\"selected\"> "),
            _createVNode(mediaGalleryImage, {
              value: __props.item.src,
              lazy: __props.lazy,
              size: __props.item.size,
              sources: __props.item.sources,
              alt: __props.item.alt,
              srcset: __props.item.srcset
            }, null, 8 /* PROPS */, ["value", "lazy", "size", "sources", "alt", "srcset"]),
            _createCommentVNode(" </zoom-wrapper> ")
          ], 64 /* STABLE_FRAGMENT */))
        : (__props.item.type === 'video')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (__props.item.hosting === 'vimeo')
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 0,
                    class: "view-media",
                    src: 'https://player.vimeo.com/video/' + __props.item.videoId,
                    title: "Video",
                    frameborder: "0",
                    allow: "autoplay; fullscreen; picture-in-picture",
                    allowfullscreen: "",
                    width: "700",
                    height: "525",
                    style: {"height":"100%"}
                  }, null, 8 /* PROPS */, _hoisted_2))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "after-image")
  ]))
}
}

})